import React, { useEffect, useState } from "react";
import { List, Datagrid, TextField, DateField, FunctionField, SelectInput, TopToolbar, ExportButton } from "react-admin";
import { Link } from "react-router-dom";
import { getResource, monthChoices } from "../common";
import { downloadCSV } from 'react-admin';
import { unparse } from 'papaparse';
import CustomCreateButton from "../components/CustomeCreateButton";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const VisitHistoryList = () => {
  const [customers, setCustomers] = useState([]);
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/all`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchUser();
  }, []);

  // const customExporter = (records) => {
  //   // エクスポートするデータをカスタムフォーマットに変換
  //   const csvData = records.map(record => {

  //     return {
  //       // "訪問No": String(record.number).padStart(5, "0"), 
  //       "訪問日": record.visitDate ? new Date(record.visitDate).toLocaleDateString() : "",
  //       "訪問内容": record.content ?? "",
  //       "担当者": record.staffName ?? "",
  //       "顧客名": getCustomer(record.customerId) ? `${getNameAndCompanyName(getCustomer(record.customerId).surname,getCustomer(record.customerId).name,getCustomer(record.customerId).companyName)}`: "",
  //     }

  //   });
  //   const csv = "\uFEFF" + unparse(csvData, { header: true });
  //   downloadCSV(csv, `訪問履歴_` + new Date().toLocaleDateString());
  // };

  const customExporter = (records) => {
    const excelData = records.map(record => ({
      "訪問日": record.visitDate ? new Date(record.visitDate).toLocaleDateString() : "",
      "訪問内容": record.content ?? "",
      "対応担当者": record.staffName ?? "",
      "顧客名": getCustomer(record.customerId)
        ? getCustomer(record.customerId).bukken : "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    worksheet['!cols'] = [
      { wch: 15 }, // 訪問日
      { wch: 120 }, // 訪問内容
      { wch: 20 }, // 担当者
      { wch: 30 }, // 顧客名
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, '訪問履歴');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    const fileName = `訪問履歴_${new Date().toLocaleDateString()}.xlsx`;
    saveAs(blob, fileName);
  };


  const getCustomer = (customerId) => {
    const customer = customers.find(req => req.id === customerId);
    return customer;
  }

  const CustomerFilters = [
    <SelectInput
      source="month"
      label={<span style={{ fontSize: "12px" }}>訪問月</span>}
      choices={monthChoices}
      alwaysOn
      sx={{
        ".MuiInputBase-root": { height: "35px" },
        ".MuiInputBase-input": {
          fontSize: "12px"
        },
      }}
    />
  ];

  const handleRowClick = (id, basePath, record) => {
    const url = `${window.location.origin}/#/${basePath}/show/${id}`;
    const features = 'width=1200,height=800,left=200,top=100,noopener,noreferrer';
    window.open(url, '_blank', features);
    return false;
  };

  const CustomersActions = () => (
    <TopToolbar>
      <CustomCreateButton basePath="/visitHistory" />
      <ExportButton exporter={customExporter} />
    </TopToolbar>
  );

  return (
    <List filters={CustomerFilters} actions={<CustomersActions />} sort={{ field: "visitDate", order: "ASC" }}>
      <Datagrid rowClick={(id, basePath, record) => handleRowClick(id, basePath, record)} bulkActionButtons={false}>
        {/* <FunctionField source="number" label="訪問No" render={(record) => {
        return String(record.number).padStart(5, "0");
      }}/> */}
        <DateField source="visitDate" label="訪問日" />
        <TextField source="content" label="訪問内容" />
        <TextField source="staffName" label="対応担当者" />
        <FunctionField
          source="customerId"
          label="顧客名"
          render={(record) => {
            const customer = getCustomer(record.customerId);
            return customer ? <Link to={`/${getResource(customer)}/show/${record.customerId}`}>{`${customer.bukken}`}</Link> : "";
          }}
          onClick={(e) => e.stopPropagation()}
        />
      </Datagrid>
    </List>
  );
}

export default VisitHistoryList;
